<template>
  <div class="company-auth-page">
    <el-card class="content-card" shadow="hover">
      <el-descriptions
        class="info-descriptions"
        :column="2"
        border
        :label-width="120"
        size="medium"
      >
        <el-descriptions-item
          v-for="field in formFields"
          :key="field.prop"
          :label="field.label"
          :span="getSpan(field.type)"
        >
          <!-- 普通弹窗输入 -->
          <template v-if="field.type === 'popup-input' || field.type === 'popup-textarea'">
            <div class="field-value-display" @click="openInputPopup(field.prop, field.label, formData[field.prop], field.maxlength, field.type === 'popup-textarea' ? 'textarea' : 'text')">
              <span v-if="formData[field.prop]" class="field-value-text">{{ formData[field.prop] }}</span>
              <span v-else class="field-value-placeholder">{{ field.placeholder }}</span>
              <i class="el-icon-edit-outline field-edit-icon"></i>
            </div>
          </template>

          <!-- 上传营业执照 -->
          <template v-else-if="field.type === 'upload'">
            <div class="upload-container">
              <el-upload
                class="upload-demo"
                action=""
                :http-request="(options) => handleUpload(options)"
                :before-upload="beforeUpload"
                :show-file-list="false"
                accept="image/*"
              >
                <el-button size="small" type="primary" :loading="uploadLoading">
                  点击上传营业执照
                </el-button>
                <div slot="tip" class="el-upload__tip">
                  仅支持图片，大小不超过2MB
                </div>
              </el-upload>
              <div v-if="formData.licenseUrl" class="uploaded-preview">
                <img :src="formData.licenseUrl" alt="营业执照预览" />
                <i class="el-icon-delete" @click="removeLicense"></i>
              </div>
            </div>
          </template>
        </el-descriptions-item>
      </el-descriptions>

      <div class="action-buttons">
        <el-button type="primary" size="medium" :loading="isSubmitting" @click="submitCompanyInfo">
          {{ submitButtonText }}
        </el-button>
      </div>
    </el-card>

    <!-- 输入弹窗 -->
    <el-dialog
      :title="inputPopupTitle"
      :visible.sync="inputDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-input
        v-if="inputPopupType !== 'textarea'"
        v-model="inputPopupValue"
        :placeholder="'请输入' + inputPopupTitle"
        :maxlength="inputPopupMaxLength"
        clearable
        show-word-limit
      />
      <el-input
        v-else
        v-model="inputPopupValue"
        type="textarea"
        :placeholder="'请输入' + inputPopupTitle"
        :maxlength="inputPopupMaxLength"
        :rows="4"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeInputPopup">取消</el-button>
        <el-button type="primary" @click="confirmInputPopup">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import axios from 'axios'

export default {
  name: 'CompanyAuth',
  data () {
    return {
      formFields: [
        { prop: 'comlist_v1', label: '公司名称', type: 'popup-input', placeholder: '请输入公司名称', maxlength: 100, required: true },
        { prop: 'comlist_v2', label: '纳税人识别号', type: 'popup-input', placeholder: '请输入纳税人识别号', maxlength: 50, required: true },
        { prop: 'comlist_v3', label: '统一社会信用代码', type: 'popup-input', placeholder: '请输入统一社会信用代码', maxlength: 18, required: true },
        { prop: 'comlist_v4', label: '经营范围', type: 'popup-textarea', placeholder: '请输入经营范围', maxlength: 500, required: true },
        { prop: 'license', label: '营业执照', type: 'upload', required: true }
      ],
      formData: {
        comlist_v1: '',
        comlist_v2: '',
        comlist_v3: '',
        comlist_v4: '',
        licenseUrl: '' // 存储上传后的图片URL（仅用于预览，提交时不使用）
      },
      companyId: null, // 新增：公司记录ID，用于判断编辑/新增
      uploadLoading: false,
      isSubmitting: false,
      // 弹窗相关
      inputDialogVisible: false,
      inputPopupTitle: '',
      inputPopupValue: '',
      inputPopupField: '',
      inputPopupMaxLength: 0,
      inputPopupType: 'text'
    }
  },
  computed: {
    // 根据是否有公司ID动态显示按钮文字
    submitButtonText () {
      return this.isSubmitting ? '提交中...' : (this.companyId ? '更新认证' : '确认认证')
    }
  },
  mounted () {
    // 组件加载时获取已有公司信息（编辑模式）
    this.fetchCompanyInfo()
  },
  methods: {
    getSpan (type) {
      return type === 'upload' ? 2 : 1
    },
    // ---------- 获取公司信息（接口 /ht/comp_lists.php  a=details） ----------
    async fetchCompanyInfo () {
      const comlist2 = localStorage.getItem('user_phone') || ''
      const crmId = localStorage.getItem('crm_id') || ''
      if (!comlist2 || !crmId) {
        // 缺少必要参数，可能未登录，静默返回
        return
      }
      try {
        const res = await request.post('/ht/comp_lists.php', {
          a: 'details',
          comlist2,
          crm_id: crmId
        })
        if (res && res.code === '0') {
          const data = res.data || {}
          // 填充表单字段（仅当返回数据存在时）
          this.formData.comlist_v1 = data.comlist_v1 || ''
          this.formData.comlist_v2 = data.comlist_v2 || ''
          this.formData.comlist_v3 = data.comlist_v3 || ''
          this.formData.comlist_v4 = data.comlist_v4 || ''
          // 若有营业执照 URL，直接显示
          if (data.comp_img) {
            this.formData.licenseUrl = data.comp_img[0].comlist_v2
          }
          // 保存公司ID，以便后续编辑时使用
          if (data.id) {
            this.companyId = data.id
          } else {
            this.companyId = null
          }
        } else {
          // 无数据或查询失败，保持表单为空（新增模式）
          console.log('暂无公司信息，进入新增模式')
          this.companyId = null
        }
      } catch (error) {
        console.error('获取公司信息失败', error)
        this.companyId = null
      }
    },
    // ---------- 上传相关 ----------
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB')
        return false
      }
      return true
    },
    async handleUpload (options) {
      const file = options.file
      const formData = new FormData()
      formData.append('file', file)
      const comlist2 = localStorage.getItem('user_phone') || ''
      const crmId = localStorage.getItem('crm_id') || ''
      formData.append('comlist2', comlist2)
      formData.append('crm_id', crmId)

      this.uploadLoading = true
      try {
        const res = await axios.post('https://caixiao.lianglianyn.com/index/upload_caix_comp.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            comlistToken: localStorage.getItem('token') || ''
          }
        })
        if (res.data && res.data.code === 0) {
          const url = res.data.url
          if (url) {
            this.formData.licenseUrl = url
            this.$message.success('营业执照上传成功')
          } else {
            this.$message.error('上传失败：未获取到图片地址')
          }
        } else {
          this.$message.error(res.data?.msg || '上传失败')
        }
      } catch (error) {
        console.error('上传失败', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.uploadLoading = false
      }
    },
    removeLicense () {
      this.formData.licenseUrl = ''
    },
    // ---------- 弹窗操作 ----------
    openInputPopup (field, title, value, maxLength = 50, type = 'text') {
      this.inputPopupField = field
      this.inputPopupTitle = title
      this.inputPopupValue = value || ''
      this.inputPopupMaxLength = maxLength
      this.inputPopupType = type
      this.inputDialogVisible = true
    },
    closeInputPopup () {
      this.inputDialogVisible = false
    },
    confirmInputPopup () {
      this.formData[this.inputPopupField] = this.inputPopupValue
      this.closeInputPopup()
    },
    // ---------- 提交公司认证（新增或编辑） ----------
    async submitCompanyInfo () {
      // 校验必填项
      const requiredFields = this.formFields.filter(f => f.required)
      for (const field of requiredFields) {
        if (field.type === 'upload') {
          if (!this.formData.licenseUrl) {
            this.$message.error('请上传营业执照')
            return
          }
          continue
        }
        if (!this.formData[field.prop]) {
          this.$message.error(`${field.label}不能为空`)
          return
        }
      }

      this.isSubmitting = true
      try {
        const comlist2 = localStorage.getItem('user_phone') || ''
        const crmId = localStorage.getItem('crm_id') || ''

        // 构建基础参数
        const params = {
          crm_id: crmId,
          comlist2: comlist2,
          comlist_v1: this.formData.comlist_v1,
          comlist_v2: this.formData.comlist_v2,
          comlist_v3: this.formData.comlist_v3,
          comlist_v4: this.formData.comlist_v4
        }

        // 判断新增还是编辑
        if (this.companyId) {
          // 编辑模式
          params.a = 'edit'
          params.id = this.companyId
        } else {
          // 新增模式
          params.a = 'add'
        }

        const data = await request.post('/ht/comp_lists.php', params)
        if (data && data.code === '0') {
          this.$message.success(this.companyId ? '公司信息更新成功' : '公司认证提交成功')
          // 更新成功后重新获取最新数据，刷新页面状态
          await this.fetchCompanyInfo()
          // 也可跳转
          setTimeout(() => {
            this.$router.push({ path: '/index/Workcg' }) // 根据实际路由调整
          }, 500)
        } else {
          this.$message.error(data?.msg || '提交失败，请重试')
        }
      } catch (error) {
        console.error('提交失败', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.company-auth-page {
  background-color: #f0f2f5;
  height: 86vh;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
}

.content-card {
  margin: 0 auto;
  .el-card__body {
    padding: 20px 30px;
  }
}

.info-descriptions {
  .el-descriptions__body .el-descriptions__table {
    table-layout: fixed;
  }

  .field-value-display {
    display: flex;
    align-items: center;
    min-height: 32px;
    padding: 0 4px;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
      background: #f5f7fa;
    }
    .field-value-text {
      flex: 1;
      font-size: 14px;
      color: #333;
      word-break: break-all;
    }
    .field-value-placeholder {
      flex: 1;
      color: #bbb;
      font-size: 14px;
    }
    .field-edit-icon {
      color: #909399;
      margin-left: 8px;
      font-size: 16px;
    }
  }

  .upload-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;

    .upload-demo {
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        padding: 8px 12px;
        text-align: center;
        transition: border-color 0.3s;
        &:hover {
          border-color: #409eff;
        }
        .el-button {
          margin: 0;
        }
      }
      .el-upload__tip {
        margin-top: 4px;
        font-size: 12px;
        color: #909399;
      }
    }

    .uploaded-preview {
      position: relative;
      display: inline-block;
      img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 6px;
        border: 1px solid #e0e0e0;
      }
      .el-icon-delete {
        position: absolute;
        top: -8px;
        right: -8px;
        background: #f56c6c;
        color: #fff;
        border-radius: 50%;
        padding: 2px;
        font-size: 14px;
        cursor: pointer;
        transition: transform 0.2s;
        &:hover {
          transform: scale(1.15);
        }
      }
    }
  }
}

.action-buttons {
  margin-top: 24px;
  text-align: center;
  .el-button {
    width: 200px;
  }
}
</style>
